module.exports = __webpack_public_path__ + "img/parcelManRight.49a7c44f.svg";